import { render } from "./CarmineUse.vue?vue&type=template&id=6c91c988&scoped=true"
import script from "./CarmineUse.vue?vue&type=script&lang=js"
export * from "./CarmineUse.vue?vue&type=script&lang=js"

import "./CarmineUse.vue?vue&type=style&index=0&id=6c91c988&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c91c988"]])

export default __exports__